<p>course-rules works!</p>
